import Vue from 'vue'
import Vuei18n from 'vue-i18n'

Vue.use(Vuei18n)

const messages = {
  en: {
    officialAccomodation: 'Official Accomodation',
    landingTitle: 'Which kind of hotel are you looking for',
    walkingDistanceCard: 'Walking distance hotels to the congress venue',
    headquartersCard: 'Headquarters Hotel',
    aroundTheCityCard: 'Hotels around the city',
    offers: 'offers',
    // seeAllHotels: `See all ${congress.hotels} hotels for ${congress.name}`,
    mapSearch: 'Search directly on the map',
    congressVenue: 'Congress Venue',
    whyHousingBureau: 'Why Housing Bureau?',
    portfolio: 'Wide portfolio of association clients with more than 1,000 congresses organized',
    support: 'On site support during the congress',
    associations: 'Members of the most prestigious international associations',
    newsletterCta: 'Subscribe to our newsletter',
    subscribeHeading: 'Sign up and get updates right in your inbox.',
    subscribePlaceholder: 'Enter your e-mail here',
    subscribeButton: 'SUBSCRIBE',
    followUs: 'Follow us',
    contact: 'Contact us',
    officialOrganizer: 'We are the official housing bureau',
    terms: 'Terms and conditions',
    cancellation: 'Cancellation Policies',
    privacy: 'Privacy Policies'
  },

  es: {

  }
}

const i18n = new Vuei18n({
  messages,
  locale: 'en'
})

export default i18n
